import { render, staticRenderFns } from "./DataCollectionItem.vue?vue&type=template&id=6e7a4f84&"
import script from "./DataCollectionItem.vue?vue&type=script&lang=js&"
export * from "./DataCollectionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports